import {
  Ard,
  FuseAccountingCentralDatastoreClient,
  GetArdResponse,
  Registration,
} from "@amzn/fuse-accounting-central-datastore-client";
import { createContext, useContext } from "react";
import { ArdRegionMap, ModalMode, RegistrationsLoadingState } from "./types";
import { Domain } from "../../config/BartLambdaConfig";

interface JemGenContextType {
  existingArds: Ard[];
  setExistingArds: (ards: Ard[]) => void;
  selectedArd: Ard | null;
  setSelectedArd: (ard: Ard | null) => void;
  selectedArdDetailed: GetArdResponse | null;
  setSelectedArdDetailed: (getArdResponse: GetArdResponse | null) => void;
  getFacdClient: (
    domain: Domain,
  ) => Promise<FuseAccountingCentralDatastoreClient | null>;
  ardRegionMap: ArdRegionMap;
  setArdRegionMap: (map: ArdRegionMap) => void;
  modalMode: ModalMode;
  setModalMode: (mode: ModalMode) => void;
  toolsContentSelection: string | null;
  setToolsContentSelection: (selection: string | null) => void;
  coaDescriptions: Map<string, string>;
  isLoadingCoaDescriptions: boolean;
  fetchArdData: (ardId: string) => Promise<void>;
  splitPanelSize: number;
  setSplitPanelSize: (size: number) => void;
  registrationsLoadingState: RegistrationsLoadingState;
  setRegistrationsLoadingState: (state: RegistrationsLoadingState) => void;
  availableRegistrations: Registration[];
  /** Registration ID from plans or ListRegistrations — null if none exists for the ARD */
  availableRegistrationId: string | null;
}

export const JemGenContext = createContext<JemGenContextType>({
  existingArds: [],
  setExistingArds: () => {},
  selectedArd: null,
  setSelectedArd: () => {},
  selectedArdDetailed: null,
  setSelectedArdDetailed: () => {},
  getFacdClient: () => Promise.resolve(null),
  ardRegionMap: new Map(),
  setArdRegionMap: () => {},
  modalMode: ModalMode.CREATE,
  setModalMode: () => {},
  toolsContentSelection: null,
  setToolsContentSelection: () => {},
  coaDescriptions: new Map(),
  isLoadingCoaDescriptions: false,
  fetchArdData: async () => {},
  splitPanelSize: 0,
  setSplitPanelSize: () => {},
  registrationsLoadingState: "not-started",
  setRegistrationsLoadingState: () => {},
  availableRegistrations: [],
  availableRegistrationId: null,
});

export const useJemGen = () => {
  const context = useContext(JemGenContext);
  if (!context) {
    throw new Error("useJemGen must be used within JemGenContextProvider");
  }
  return context;
};
